import { render, staticRenderFns } from "./FaqDetail2.vue?vue&type=template&id=03507a98&scoped=true&"
import script from "./FaqDetail2.vue?vue&type=script&lang=js&"
export * from "./FaqDetail2.vue?vue&type=script&lang=js&"
import style0 from "./FaqDetail2.vue?vue&type=style&index=0&id=03507a98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03507a98",
  null
  
)

export default component.exports